// extracted by mini-css-extract-plugin
export default {"container":"CommunityRulesAdmin_container__qFeEG","form":"CommunityRulesAdmin_form__LMPOT","list":"CommunityRulesAdmin_list__5bHNt"};